module.exports = __webpack_public_path__ + "static/img/xpfbt1.7fe42909.png";